import React from "react"
import {useEffect} from 'react';
import { Link} from "gatsby"
import headerStyle from './header.module.css';
const ListLink = props => (
  <li style={{ display: `inline-block`, marginRight: `1rem` }}>
    <Link className={props.className} activeClassName={ headerStyle.active} to={props.to}>{props.children}</Link>
  </li>)

function modeSwitch() {
    var newMode = document.body.classList.contains('dark') ? 'normal' : 'dark';
    var d = new Date();
    d.setTime(d.getTime() + (30*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = `mode=${newMode};${expires};path=/`;
    document.body.classList.toggle('dark');
}
export default function Header(props) {
    useEffect(()=> {
        let currentMode = document.cookie.replace(/(?:(?:^|.*;\s*)mode\s*\=\s*([^;]*).*$)|^.*$/, "$1");       
        currentMode === 'dark' ? document.body.classList.add('dark') : document.body.classList.remove('dark');
    })
  return <header  className={`${headerStyle.nav}`} style={{marginBottom: `3.5rem` }}>
            <div className={headerStyle.container}>
                <div className={`${headerStyle.logo} brand-logo`}>
                    <Link to="/" style={{ textShadow: `none`, backgroundImage: `none` }}>
                        <h3 className={headerStyle.title}>{props.headerText}</h3>
                    </Link>
                    <div onClick={modeSwitch} className="modeSwitcher"> </div>
                </div>
                <ul className={headerStyle.menu} style={{ listStyle: `none` }}>
                    <div style={{ display: `inline` }}>
                        <ListLink to="/">Home</ListLink>
                        <ListLink to="/blog/">Blog</ListLink>
                        <ListLink to="/about/">About</ListLink>
                        <ListLink to="/projects/">Projects</ListLink>
                    </div>
                </ul>
            </div>
        </header>
}